// render-elem.ts
import { h } from "snabbdom";
import { DomEditor } from "@wangeditor/editor";

const confVideo = {
  type: "videoAttachment", // 节点 type ，重要！！！
  renderElem(elem, children, editor) {
    // 当前节点是否选中
    const selected = DomEditor.isNodeSelected(editor, elem);
    const { videoUrl = "", videoName = "", videoCover = "" } = elem;

    // 构建 vnode
    const vnode = h(
      "a",
      {
        props: {
          contentEditable: false, // 不可编辑
          href: "javascript:void(0)",
        },
        style: {
          cursor: "pointer",
          margin: "0 4px",
          display: "inline-flex",
          position: "relative",
          boxShadow: selected // 选中/不选中，样式不一样
            ? "0 0 0 3px #78affd" // wangEditor 提供了 css var https://www.wangeditor.com/v5/theme.html
            : "none",
          borderRadius: "4px",
          overflow: "hidden",
        },
        on: {
          click(e) {
            editor.emit("videoAttachment:el:click", {
              videoUrl,
              videoName,
              videoCover,
            });
            // e.preventDefault();
            // e.stopPropagation();
          },
        },
      },
      [
        h("img", {
          props: {
            contentEditable: false, // 不可编辑
            src: videoCover,
            width: 300,
          },
        }),

        h(
          "span",
          {
            props: {
              contentEditable: false, // 不可编辑
            },
            style: {
              position: "absolute",
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              background: "rgba(0, 0, 0, 0.3)",
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          [
            h(
              "img",
              {
                props: {
                  contentEditable: false, // 不可编辑
                  src: "https://static.rhkj.com/renhe_fe/other/play-btn1.png",
                  width: 40,
                  height: 40,
                },
                style: {
                  cursor: "pointer",
                },
              },
              []
            ),
          ]
        ),
      ]
    );

    return vnode;
  },
};

const confFile = {
  type: "fileAttachment", // 节点 type ，重要！！！
  renderElem(elem, children, editor) {
    // 当前节点是否选中
    const selected = DomEditor.isNodeSelected(editor, elem);
    const {
      fileStorageId = "",
      fileName = "",
      fileExtension = "",
      fileType = "",
    } = elem;

    const iconUrl = {
      1: "https://renhe-platform-prod.oss-cn-shanghai.aliyuncs.com/2025-12-15/1765795870222_office-excel.png",
    }[fileType];

    // 构建 vnode
    const vnode = h(
      "a",
      {
        props: {
          contentEditable: false, // 不可编辑
          href: "javascript:void(0)",
        },
        style: {
          cursor: "pointer",
          margin: "0 4px",
          display: "inline-flex",
          position: "relative",
          boxShadow: selected // 选中/不选中，样式不一样
            ? "0 0 0 3px #78affd" // wangEditor 提供了 css var https://www.wangeditor.com/v5/theme.html
            : "none",
          borderRadius: "4px",
          overflow: "hidden",
          flexDirection: "column",
          alignItems: "center",
        },
        on: {
          click(e) {
            editor.emit("fileAttachment:el:click", {
              fileStorageId,
              fileName,
              fileExtension,
              fileType,
            });
            // e.preventDefault();
            // e.stopPropagation();
          },
        },
      },
      [
        h(
          "i",
          {
            props: {
              contentEditable: false, // 不可编辑
            },
            style: {
              width: "40px",
              height: "40px",
              marginBottom: "5px",
              background: `url(${iconUrl})`,
              backgroundSize: "100%",
            },
          },
          []
        ),
        h(
          "span",
          {
            props: {
              contentEditable: false, // 不可编辑
            },
            style: {
              maxWidth: "100px",
              textAlign: "justify",
              lineHeight: "1.4",
              fontSize: "13px",
              whiteSpace: "normal",
            },
          },
          [fileName]
        ),
      ]
    );

    return vnode;
  },
};

export default { confVideo, confFile };
